import Radio from './radio.element.js';

export default Radio;

Radio.define('wje-radio', Radio);
